import { join } from '../../utils/strings';
import { getGenreParam } from '../../utils/getSearchParam';
import {
  navigateToProductListWithClusters,
  navigateToProductListWithClusterAndGenre,
} from '../../utils/navigations';

export const navigateToCluster = ({
  history,
  clusterType,
  onSelectCluster,
  location,
}) => (clusterName) => {
  const genre = getGenreParam(location);
  const clusters = join({
    part2: clusterName,
    part1: clusterType,
    separator: '|',
  });

  onSelectCluster();
  if (genre) {
    navigateToProductListWithClusterAndGenre({
      history,
      clusters: `${genre} | ${clusters}`,
      genre,
    });
  } else {
    navigateToProductListWithClusters({ history, clusters });
  }
};
